import React from 'react';

export const displayTicketValue = (value) => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.map(item => typeof item === 'object' && item !== null
    ? Object.values(item).filter(part => part !== '' && part != null).map(displayTicketValue).join(' — ')
    : displayTicketValue(item)).join('\n') || '—';
  if (value && typeof value === 'object') return Object.entries(value).map(([key, item]) => `${key}: ${displayTicketValue(item)}`).join('\n') || '—';
  return value === null || value === undefined || value === '' ? '—' : String(value);
};

const TicketFieldList = ({ fields }) => (
  <dl className="ticket-field-list">
    {fields.map(field => <div key={field.key || field.label}>
      <dt>{field.label}</dt><dd>{displayTicketValue(field.value)}</dd>
    </div>)}
  </dl>
);

export default TicketFieldList;
